module.exports = __webpack_public_path__ + "static/media/referafriend.20d0d9f4.jpg";